import React from 'react';
import { motion } from 'framer-motion';
import { Check, LockIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section id="checkout" className="py-14 px-4 sm:px-6 lg:px-8 bg-dark-card border-y border-dark-border relative overflow-hidden mt-[0px] mb-[0px]" data-id="element-82">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-[1000px] bg-gold/5 blur-[120px] pointer-events-none rounded-full" data-id="element-83" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-84">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-85">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-86">
            <div className="relative mx-auto w-full max-w-md perspective-1000" data-id="element-87">
              <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/5 transform rotate-y-[5deg] rotate-x-[5deg]" data-id="element-88"></div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2 bg-dark border border-dark-border p-8 sm:p-10 rounded-3xl" data-id="element-89">
            <h3 className="text-3xl sm:text-4xl font-serif text-white mb-8" data-id="element-90">
              Get{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-91">
                Access Today
              </span>
            </h3>

            <div className="space-y-4 mb-10" data-id="element-92">
              {['Full system access', 'All 10 modules', 'Lifetime access', '7-day money-back guarantee'].map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-93">
                  <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center shrink-0" data-id="element-94">
                    <Check className="w-4 h-4 text-gold" data-id="element-95" />
                  </div>
                  <span className="text-lg text-zinc-300" data-id="element-96">{item}</span>
                </div>)}
            </div>

            <div className="mb-4" data-id="element-97">
              <div className="flex items-baseline gap-3 mb-1" data-id="element-98">
                <span className="text-zinc-500 line-through text-[28px]" data-id="element-99">
                  $49.99
                </span>
                <span className="text-5xl sm:text-6xl font-bold text-white" data-id="element-100">
                  $19.99
                </span>
              </div>
              <p className="text-sm text-zinc-400 tracking-wide" data-id="element-101">
                One-time payment • Lifetime access
              </p>
            </div>

            <Button href="#checkout" className="w-full py-5 text-xl" data-id="element-102">
              Get Instant Access
            </Button>

            <p className="text-center text-sm text-zinc-500 flex items-center justify-center gap-1.5 mt-[0px] mb-[0px]" data-id="element-103">
              <LockIcon className="w-3.5 h-3.5" data-id="element-104" />
              Secure checkout
            </p>

            <div className="mt-6 rounded-2xl border border-gold/10 bg-gold/[0.03] px-6 py-7 sm:px-8 sm:py-8 text-center" data-id="element-105">
              <svg className="w-4 h-4 text-gold/70 mx-auto mb-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-106">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-107" />
              </svg>
              <h4 className="text-lg font-semibold text-white mb-2" data-id="element-108">
                7-Day Money-Back Guarantee
              </h4>
              <p className="text-sm text-zinc-500" data-id="element-109">
                Try it risk-free. Full refund if it's not for you.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}